import { render, staticRenderFns } from "./ComparativeLiteratureInfo.vue?vue&type=template&id=6e5751f0&scoped=true&"
import script from "./ComparativeLiteratureInfo.vue?vue&type=script&lang=ts&"
export * from "./ComparativeLiteratureInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ComparativeLiteratureInfo.vue?vue&type=style&index=0&id=6e5751f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5751f0",
  null
  
)

export default component.exports